import React from 'react';
import styled, { css } from 'styled-components/macro';
import tw from 'tailwind.macro';
import TrustBox from '../../../components/TrustBox/CustomTrustBox';
import { P0 } from '../../../components/Typographies/Paragraph';
import { H1 } from '../../../components/Typographies/Title';
import DoubleLeaf from '../../../images/illustrated/double-leaf.png';
import { NAVIGATION } from '../../App/constants';

const Container = styled.div`
  ${tw`flex`}
  gap: var(--size-medium);
`;

const Wrapper = styled.div`
  ${tw`w-full flex flex-col items-center md:items-start`}
  gap:var(--size-medium)
`;

const Decoration = styled.div`
  ${tw`hidden xl:block`}
`;

const TrustBoxStyle = css`
  ${tw`bg-white py-medium px-medium2 rounded-15`}
`;

const Links = styled.div`
  ${tw`flex justify-between`}
  gap:var(--size-medium)
`;

const Image = styled.img`
  ${tw`w-full`}
  max-width: 140px;
`;

const Content = styled.div<{ withBackground: boolean }>`
  ${tw` hidden md:flex md:flex-col`}
  gap:var(--size-medium);

  ${({ withBackground }) =>
    withBackground &&
    css`
      ${tw`rounded-30 p-medium`}
      background:#ffffffd1;
    `}
`;

interface InitialHeaderProps {
  isMobileApp: boolean;
  withBackground: boolean;
  header: React.ReactNode;
  subHeader: React.ReactNode;
  isCdiscount: boolean;
}

const InitialHeader: React.FC<InitialHeaderProps> = ({
  header,
  isCdiscount,
  isMobileApp,
  subHeader,
  withBackground,
}) => {
  return (
    <Container>
      <Decoration>
        <img alt="Two white leaf" src={DoubleLeaf} />
      </Decoration>

      <Wrapper>
        <Content withBackground={withBackground}>
          <H1>{header}</H1>
          <P0>{subHeader}</P0>
        </Content>
        {!isMobileApp && (
          <React.Fragment>
            <TrustBox customStyle={TrustBoxStyle} />
            {isCdiscount === false && (
              <Links>
                <a
                  href={NAVIGATION.ANDROID_APP_LINK}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Téléchargez l'application Tictactrip sur google play"
                    src="/assets/footer/google-play-90h.webp"
                  />
                </a>

                <a
                  href={NAVIGATION.IOS_APP_LINK}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Téléchargez l'application Tictactrip sur l'app store"
                    src="/assets/footer/app-store-90h.webp"
                  />
                </a>
              </Links>
            )}
          </React.Fragment>
        )}
      </Wrapper>
    </Container>
  );
};

export default InitialHeader;
